import { render } from "./TournamentActivityEditPage.vue?vue&type=template&id=6b730618"
import script from "./TournamentActivityEditPage.vue?vue&type=script&lang=js"
export * from "./TournamentActivityEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__